import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'components/Panel/Panel';
import styles from './InstructionBox.module.scss';

const InstructionBox = (props) => {
  return (
    <React.Fragment>
      <Panel
        className={props.panelClassname ? `${props.panelClassname}` : ''}
        style={{ ...props.panelStyle }}
      >
        <div
          className={styles.container}
          style={{
            ...props.containerStyle,
          }}
        >
          <p
            className={styles.text}
            style={{
              ...props.textStyle,
            }}
          >
            {props.text}
          </p>
        </div>
      </Panel>
    </React.Fragment>
  );
};

InstructionBox.propTypes = {};

InstructionBox.defaultProps = {
  panelStyle: { border: '3px solid gold' },

  containerStyle: {},

  svgStyle: {},

  text: '',
  textStyle: {},
};

export default InstructionBox;
